class SpecialOfferModal {
    constructor() {
        this.modal = $('#specialOfferModal');
        this.registerEvents();
    }

    registerEvents() {
        $(document).ready(() => {
            return this.showModal();
        });

        return this.modal.on('click', '[data-register]', e => {
            return this.handleInput(e);
        });
    }

    showModal() {
        return setTimeout((() => {
            return this.modal.modal('show');
        }), 1000);
    }

    hideModal() {
        return this.modal.modal('hide');
    }

    handleInput(e) {
        e.preventDefault();
        const $btn = $(e.currentTarget);

        const shouldGoToRegister = $btn.data('Register.js');
        if (shouldGoToRegister) {
            if (window.location.href !== $btn.attr('href')) {
                window.location = $btn.attr('href');
            }
            this.hideModal();
            return;
        }

        const $request = $.ajax({
            url: '/_ajax/offer_response',
            method: 'POST',
            data: {
                response: shouldGoToRegister,
            },
        });

        return $request.always(() => {
            return this.hideModal();
        });
    }
}

export default SpecialOfferModal;
